export default __webpack_public_path__ + "static/media/290eac12d88c6f22838cf8e4605f5cb11575645920672.1fbefda2.webp";